<div class="space-y-4">
  <!-- Légende + action -->
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div class="flex flex-wrap items-center gap-4 text-xs text-gray-600 dark:text-gray-300">
      <span class="flex items-center gap-1.5">
        <span class="size-3 rounded-sm border border-gray-300 bg-white dark:border-gray-600 dark:bg-transparent"></span>
        {{ 'vehicles.disponible' | t }}
      </span>
      <span class="flex items-center gap-1.5">
        <span class="size-3 rounded-sm bg-gray-200 dark:bg-white/10"></span>
        {{ 'vehicles.indisponibleHorsMiseA' | t }}
      </span>
      <span class="flex items-center gap-1.5">
        <span class="size-3 rounded-sm" style="background-color: rgba(11,140,0,0.35)"></span>
        {{ 'vehicles.reserveClicLocation' | t }}
      </span>
      <span class="flex items-center gap-1.5">
        <span class="size-3 rounded-sm" style="background-color: rgba(245,158,11,0.55)"></span>
        {{ 'vehicles.bloqueParLeProprietaire' | t }}
      </span>
      @if (loading()) {
        <span class="text-gray-400">{{ 'vehicles.chargement' | t }}</span>
      }
    </div>

    <button
      type="button"
      (click)="openModal()"
      class="inline-flex items-center gap-1.5 rounded-lg bg-brand-500 px-3.5 py-2 text-sm font-medium text-white transition hover:bg-brand-600"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      </svg>
      {{ 'vehicles.bloquerUnCreneau' | t }}
    </button>
  </div>

  @if (error()) {
    <div class="rounded-lg border border-error-200 bg-error-50 px-3 py-2 text-sm text-error-700 dark:border-error-800 dark:bg-error-500/10 dark:text-error-400">
      {{ error() }}
    </div>
  }

  <full-calendar [options]="calendarOptions"></full-calendar>

  <p class="text-xs text-gray-500 dark:text-gray-400">
    <span [innerHTML]="'vehicles.calendarLegend' | t"></span>
    @if (gracePeriodHours() != null) {
      {{ 'vehicles.uneMargeDe' | t }} {{ gracePeriodHours() }} {{ 'vehicles.hEstAppliqueeAutour' | t }}
    }
  </p>

  <!-- Mes blocages -->
  <div class="rounded-xl border border-gray-100 bg-gray-50 p-4 dark:border-gray-800 dark:bg-white/[0.02]">
    <h3 class="text-sm font-semibold text-gray-800 dark:text-white/90">{{ 'vehicles.mesBlocages' | t }}</h3>
    @if (blackoutsLoading()) {
      <p class="mt-2 text-xs text-gray-400">{{ 'vehicles.chargementDesBlocages' | t }}</p>
    } @else if (blackouts().length === 0) {
      <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">{{ 'vehicles.aucunCreneauBloqueLe' | t }}</p>
    } @else {
      <ul class="mt-3 divide-y divide-gray-200 dark:divide-gray-800">
        @for (bo of blackouts(); track bo.id) {
          <li class="flex items-center justify-between gap-3 py-2.5">
            <div class="min-w-0">
              <p class="text-sm font-medium text-gray-800 dark:text-white/90">
                {{ bo.startDate | ldate: 'dd MMM yyyy' }} → {{ bo.endDate | ldate: 'dd MMM yyyy' }}
              </p>
              @if (bo.reason) {
                <p class="truncate text-xs text-gray-500 dark:text-gray-400">{{ bo.reason }}</p>
              }
            </div>
            <button
              type="button"
              (click)="askDelete(bo)"
              class="shrink-0 rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-700 transition hover:bg-white hover:text-error-600 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5"
            >
              {{ 'vehicles.lever' | t }}
            </button>
          </li>
        }
      </ul>
    }
  </div>
</div>

<!-- Modal : bloquer un créneau -->
<app-modal [isOpen]="modalOpen()" (close)="closeModal()" className="max-w-md p-6">
  <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">{{ 'vehicles.bloquerUnCreneau' | t }}</h3>
  <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
    {{ 'vehicles.marquezUnePlageIndisponible' | t }}
  </p>

  @if (submitError()) {
    <div class="mt-4 rounded-lg border border-error-200 bg-error-50 px-3 py-2 text-sm text-error-700 dark:border-error-800 dark:bg-error-500/10 dark:text-error-400">
      {{ submitError() }}
    </div>
  }

  <form [formGroup]="blackoutForm" (ngSubmit)="submitBlackout()" class="mt-5 space-y-4">
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">{{ 'vehicles.du' | t }} <span class="text-error-500">*</span></label>
        <app-date-field formControlName="startDate" [min]="todayStr" />
      </div>
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Au <span class="text-error-500">*</span></label>
        <app-date-field formControlName="endDate" [min]="blackoutForm.controls.startDate.value || todayStr" />
      </div>
    </div>

    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Motif (optionnel)</label>
      <input type="text" formControlName="reason" maxlength="120" placeholder="Ex. : usage personnel"
        class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90" />
    </div>

    <div class="flex justify-end gap-2 pt-2">
      <button type="button" (click)="closeModal()" [disabled]="submitting()" class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5">{{ 'vehicles.annuler' | t }}</button>
      <button type="submit" [disabled]="submitting() || blackoutForm.invalid" class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-50">
        @if (submitting()) {
          <svg class="size-4 animate-spin" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" class="opacity-25"></circle><path fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" class="opacity-75"></path></svg>
          Blocage…
        } @else { Bloquer }
      </button>
    </div>
  </form>
</app-modal>

<!-- Confirmation : lever un blocage -->
<app-confirm-modal
  [open]="deleteTarget() !== null"
  [busy]="deleting()"
  [error]="deleteError()"
  [title]="'vehicles.leverCeBlocage' | t"
  [confirmLabel]="'vehicles.leverLeBlocage' | t"
  [busyLabel]="'vehicles.levee' | t"
  (confirm)="confirmDelete()"
  (close)="cancelDelete()"
>
  @if (deleteTarget(); as bo) {
    {{ 'vehicles.leCreneauDu' | t }} {{ bo.startDate | ldate: 'dd MMM yyyy' }} au {{ bo.endDate | ldate: 'dd MMM yyyy' }}
    {{ 'vehicles.redeviendraImmediatementDisponibleA' | t }}
  }
</app-confirm-modal>
